import UrlHelpers from "./url";
import {i18n} from "./i18n";
import {addIcon, pageBackIcon} from "./icons";
import {FieldHandler} from "./fieldHandler";
import {setContextActions} from "./contextActions";
import {organization_created, tenant_created, tenant_deleted, tenant_updated} from "./dapiEventUris";
import * as mdc from 'material-components-web';
import {dialog, textField} from "material-components-web";
import {errorDto} from "./errorHandler";
import {MaterialHelpers} from "./materialHelpers";
import {isOnlyText} from "./validation";

export class OrganizationList {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();
    private _mdcTextFields: textField.MDCTextField[] = [];

    constructor() {
        this._loadMaterial();
        this._dapi.addResourceEventListener('changed', this._changed_event);
        this._dapi.addResourceEventListener('deleted', this._deleted_event);
        this._addContextActions();
        //setTimeout(this._setTour, 1500);
        //
        let createOrgaBtn = document.getElementById('btnCreate');
        if(createOrgaBtn){
            createOrgaBtn.addEventListener('click', this._create_click);
        }
        let btnEmptyList = document.getElementById('btnEmptyList');
        if(btnEmptyList){
            btnEmptyList.addEventListener('click', this._open_create_orga_dialog);
        }
    }

    private _loadMaterial = ():void => {
        const textfields = document.querySelectorAll('.mdc-text-field');
        Array.apply(null, textfields).forEach((textfield) => {
            //Workaround for missing animation on prefilled mdc-text-fields
            this._mdcTextFields.push(textField.MDCTextField.attachTo(textfield));
        });
        const dialogs = document.querySelectorAll('.mdc-dialog');
        Array.apply(null, dialogs).forEach((d) => {
            dialog.MDCDialog.attachTo(d);
        });
    };

    private _addContextActions = (): void => {
        let ctx: Array<IContextAction> = new Array<IContextAction>();
        ctx.push({
            title: this._i18n.getTranslation('organizationList_btn_createOrganization'),
            icon: addIcon, //'https://s3.eu-central-1.amazonaws.com/dv-cloud-center/img/uEA76-zoomin-32x32.png',
            callback: () => {
                // this._create_click();
                this._open_create_orga_dialog();
            }
        });
        // this._dapi.setContextActions(ctx);
        setContextActions(this._dapi, this._i18n, ctx);
    };

    private _open_create_orga_dialog = ():void => {
        const div = document.getElementById('modalCreateOrganization');
        const dialog = new mdc.dialog.MDCDialog(div);
        dialog.listen('MDCDialog:closed', (e:dialog.MDCDialogCloseEventDetail) => {
            const fields = document.querySelectorAll('mdc-text-field__input');
            Array.apply(null, fields).forEach((field) => {
                if (field.id !== 'searchValue') {
                    MaterialHelpers.setTextFieldValue(field.id, '');
                }
            })
        });
        dialog.open();
    };

    private _create_click = (): void => {
        if (this._areOrgaInputFieldsValid()) {
            this._createOrga().then(value => {
                this._dapi.dispatchResourceEvent({
                    name: 'changed',
                    uri: organization_created
                });
                this._dapi.navigate(value);
            }).catch((error) => {
                alert(error);
            });
        } else {
            console.error('Any organization fields are invalid. Please check!');
        }
    };

    private _areOrgaInputFieldsValid = (): boolean => {
        const inputs = ['organame'];
        let allValid = true;
        inputs.forEach((id: string) => {
            if (!this._validateMaterialInput(id)) {
                allValid = false;
            }
        });
        return allValid;
    };

    private _validateMaterialInput = (inputId: string): boolean => {
        let inputValue = (<HTMLInputElement>document.getElementById(inputId)).value;
        // const helperTextId = `${inputId}HelperText`;
        const id = `${inputId}_container`;
        if (inputValue.isNullOrEmpty()) {
            MaterialHelpers.setTextFieldHelperText(id, this._i18n.getTranslation('order_wizard_error_field_empty_message'), true);
            return false;
        }
        if (!isOnlyText(inputValue)) {
            MaterialHelpers.setTextFieldHelperText(id, this._i18n.getTranslation('order_wizard_error_field_invalid_char_message'), true);
            return false;
        }
        MaterialHelpers.removeTextFieldHelperText(id);
        return true;
    };

    private _createOrga = (): Promise<string> => {
        let promise = new Promise<string>((resolve, reject) => {
            let url = UrlHelpers.getLinkRelHref('self');
            if (url.isNullOrEmpty()) {
                console.error('Cannot find link relation for "organizations"');
            }
            let orgaName = FieldHandler.getFieldValue('organame');
            let req = new Request(url, {
                method: 'POST',
                headers: {
                    'accept': 'application/json'
                },
                body: JSON.stringify({
                    name: orgaName
                }),
            });
            fetch(req, {credentials: "same-origin"})
                .then((response) => {
                    if (response.status === 201) {
                        let orgaUrl = response.headers.get('location');
                        response.json().then(value => {
                            let orgaId = value.replace(/"/g, '');
                            console.log(`create organization success. ID: ${orgaId}`);
                            this._updateOrga(orgaId, orgaName, orgaUrl)
                                .then(() => {
                                    resolve(orgaUrl);
                                })
                                .catch((error) => {
                                    reject(error);
                                });
                        });
                    } else {
                        response.json().then((value: errorDto) => {
                            console.error(`create organization failed with status ${response.status}: ${value.description}`);
                            reject(value.description);
                        });
                    }
                })
                .catch((error) => {
                    error.json().then((value: errorDto) => {
                        console.error(`create organization failed with status ${error.status}: ${value.description}`);
                        reject(value.description);
                        return
                    });
                    reject(error);
                });
        });
        return promise;
    };

    private _updateOrga = (orgaId: string, orgaName: string, orgaUrl: string): Promise<string> => {
        let promise = new Promise<string>((resolve, reject) => {
            let req = new Request(orgaUrl, {
                method: 'PUT',
                headers: {
                    'accept': 'application/json'
                },
                body: JSON.stringify({
                    organization: {
                        id: orgaId,
                        name: orgaName,
                    }
                })
            });
            fetch(req, {credentials: "same-origin"})
                .then((response) => {
                    if (response.status === 200) {
                        console.log(`update organization ${orgaId} success`);
                        resolve(orgaId);
                    } else {
                        response.json().then((value: errorDto) => {
                            console.error(`update organization information failed with status ${response.status}: ${value.description}`);
                            reject(value.description);
                        });
                    }
                })
                .catch((error) => {
                    error.json().then((value: errorDto) => {
                        console.error(`create organization failed with status ${error.status}: ${value.description}`);
                        reject(value.description);
                        return
                    });
                    reject(error);
                });
        });
        return promise;
    };

    private _changed_event = (resouceEvent: IResourceEvent) => {
        switch (resouceEvent.uri) {
            case organization_created:
            case tenant_created:
            case tenant_updated:
            case tenant_deleted:
                window.location.reload();
                break;
        }
    };

    private _deleted_event = (resourceEvent: IResourceEvent) => {
        window.location.reload();
            // let items = this._dux.query(".item");
            // for (let i = 0; i < items.length; i++) {
            //     let item = items[i];
            //     let link = this._dux.query(item).data('href');
            //     if (link === resourceEvent.uri) {
            //         this._dux.query(item).remove();
            //         this._dapi.navigate('dapi_blank');
            //         break;
            //     }
            // }
    };
}

export interface create_orga_request_dto {
    name:string
}